export default __webpack_public_path__ + "static/media/banner03.6f9873db.png";